// Outline of the wax seal, in a 100 × 100 box. Also drawn on share images.
export const SEAL_PATH =
  "M50 4c9 0 13 7 21 9s16-1 20 8-3 14-2 22 9 13 6 22-12 9-17 15-5 15-14 17-13-6-21-6-15 7-23 2-5-14-9-21S-1 60 3 51s12-10 14-18 0-16 8-21 13 2 25-8Z";

// The wax seal. It is the only thing on the site in this colour, so use it
// once per view at most.
export function Seal({ className, title }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 100 100" className={className} role={title ? "img" : undefined} aria-hidden={title ? undefined : true}>
      {title ? <title>{title}</title> : null}
      <path d={SEAL_PATH} fill="var(--color-seal)" />
      <circle cx="50" cy="50" r="30" fill="none" stroke="#fff" strokeOpacity="0.35" strokeWidth="1.5" />
      <text
        x="50"
        y="61"
        textAnchor="middle"
        fontFamily="var(--font-serif), Georgia, serif"
        fontStyle="italic"
        fontSize="32"
        fill="#fff"
      >
        DJ
      </text>
    </svg>
  );
}
